module.exports = __webpack_public_path__ + "static/media/logoutv2.afa75a84.svg";